export function deserializeQueryStringArray(
  serializedArray: string | null | undefined
): string[] | null {
  return serializedArray?.split(",").filter(Boolean) || null
}
